const iso = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${dd}`;
};

// Per-night rate priority: date-range price > monthly seasonal > base (mirrors backend core/utils.py)
export const nightlyRate = (room, date, isBulk) => {
    if (!room) return 0;
    const ds = iso(date);
    for (const rp of room.date_range_prices || []) {
        if (rp.start && rp.end && rp.start <= ds && ds <= rp.end) {
            const val = Number(isBulk ? rp.price_bulk : rp.price_individual) || 0;
            if (val > 0) return val;
        }
    }
    const m = date.getMonth() + 1;
    const sp = (room.seasonal_prices || []).find((s) => Number(s.month) === m);
    if (sp) return Number(isBulk ? sp.price_bulk : sp.price_individual) || 0;
    return Number(isBulk && room.price_bulk != null ? room.price_bulk : room.price_individual) || 0;
};

export const stayTotal = (room, checkInISO, nights, isBulk) => {
    if (!room || !checkInISO || !nights) return 0;
    const start = new Date(`${checkInISO}T00:00:00`);
    if (Number.isNaN(start.getTime())) return 0;
    let sum = 0;
    for (let n = 0; n < nights; n++) {
        const d = new Date(start);
        d.setDate(start.getDate() + n);
        sum += nightlyRate(room, d, isBulk);
    }
    return sum;
};

// Lowest nightly price across a hotel's rooms for a given date (defaults to today)
export const lowestNightly = (hotel, dateISO = null, isBulk = false) => {
    const d = dateISO ? new Date(`${dateISO}T00:00:00`) : new Date();
    if (Number.isNaN(d.getTime())) return 0;
    const prices = (hotel?.rooms || []).map((r) => nightlyRate(r, d, isBulk)).filter((p) => p > 0);
    return prices.length ? Math.min(...prices) : 0;
};
